import React from 'react'
import createG2 from 'g2-react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
// import _values from 'lodash/values'
import _get from 'lodash/get'
// import _set from 'lodash/set'
import _keys from 'lodash/keys'
import _find from 'lodash/find'
import _sortBy from 'lodash/sortBy'
import moment from 'moment'
// import { COLORS } from './styles'
import config from '~/config'
// const colors = _values(config.ui.colors)

// TODO: use id instead of name and set alias

const ForcingDataChart = ({ dataRecords, dataTypeIds, category, view: { mode, daysOffset }, data: { now } }) => {
  const today = moment(now).clone().set({ hour: 0, minute: 0, second: 0 })
  const startDate = today.format('YYYY-MM-DD@HH:mm:ss')
  const endDate = today.clone().add({ days: 7 }).format('YYYY-MM-DD@HH:mm:ss')
  const categoryConfig = _get(config, 'app.categories', []).find(cat => cat.id === category.id)
  const chartType = _get(categoryConfig, 'chart', 'line')

  const dataTypes = _keys(dataRecords.reduce((result, rec) => ({
    ...result,
    [rec.type.name]: 1
  }), {}))
  // console.log({ dataRecords })
  // const dataValues = _values(dataRecords.reduce((result, rec) => {
  //   // console.log(rec.observedTimestamp)
  //   _set(result, [rec.observedTimestamp, rec.type.name], rec.value)
  //   _set(result, [rec.observedTimestamp, 'observedTimestamp'], moment(rec.observedTimestamp).format('YYYY-MM-DD@HH:mm:ss'))
  //   // _set(result, [rec.observedTimestamp, 'observedTimestampISO'], moment(rec.observedTimestamp).toISOString())
  //   return result
  // }, {}))
  const dataSource = _sortBy(dataRecords, ['observedTimestamp'])
    .map(({ typeName, value, observedTimestamp }) => ({
      typeName,
      value,
      observedTimestamp: moment(observedTimestamp).format('YYYY-MM-DD@HH:mm:ss')
    }))
  // console.log({ dataSource })
  let observedTimestamp

  const currentDay = today.clone().add(daysOffset, 'day')
  const record = _find(dataSource, rec => currentDay.isSame(moment(rec.observedTimestamp, 'YYYY-MM-DD@HH:mm:ss', true), 'day'))
  if (record) {
    observedTimestamp = record.observedTimestamp
  }

  const Line = createG2(chart => {
    let offset = 5
    dataTypes.forEach((typeName, i) => {
    // const typeConfig = _get(config, ['app', 'parameters', type])
    // const typeConfig = _get(config, ['app', 'parameters', type])
    // const typeConfig = _get(config, 'app.parameters').find(t => t.name === type)
    // const typeConfig = _get(config, 'app.parameters').find(t => t.id === parseInt(typeId, 10))
    // const typeName = _get(typeConfig, 'name')
    // offset += 10
    // chart.axis(typeName, {
    //   position: 'left',
    //   labels: {
    //     label: {
    //       fill: colors[i],
    //       fontSize: 8
    //     },
    //     autoRotate: false
    //   },
    //   labelOffset: offset,
    //   title: {
    //     fontSize: 10,
    //     fontWeight: 'bold',
    //     fill: colors[i],
    //     textAlign: 'center'
    //   },
    //   titleOffset: offset + 24
    // })
    // chart.col(typeName, {
    //   alias: typeName
    // })
      if (observedTimestamp) {
        chart.guide().line([observedTimestamp, -1000], [observedTimestamp, 1000], {
          stroke: '#999'
          // lineDash: [0, 2, 2],
          // lineWidth: 3
        })
      }
    //   offset += 40
    //   chart[chartType]().position(`observedTimestamp*${typeName}`).color(colors[i]).shape('spline').size(2)
    })
    chart[chartType]().position(`observedTimestamp*value`).color('typeName') // .color(colors[i]).shape('spline').size(2)
    chart.axis(categoryConfig.name, {
      position: 'left',
      labels: {
        label: {
          // fill: colors[i],
          fontSize: 8
        },
        autoRotate: false
      },
      labelOffset: offset,
      title: {
        fontSize: 10,
        fontWeight: 'bold',
        // fill: colors[i],
        textAlign: 'center'
      },
      titleOffset: offset + 24
    })
    let prevDate
    chart.axis('value', {
      title: false
    })
    chart.axis('observedTimestamp', {
      formatter: (dateTime, item, index) => {
        const $dateTime = moment(dateTime, 'YYYY-MM-DD@HH:mm:ss', true)
        if (!$dateTime.isSame(prevDate, 'day')) {
          prevDate = $dateTime
          // return $dateTime.format('YYYY-MM-DD')
          return $dateTime.format('MMM DD')
        }
        prevDate = $dateTime
        return $dateTime.format('HH:mm:ss')
      },
      labels: {
        label: {
          textAlign: 'right',
          fontSize: 8,
          textBaseline: 'top',
          rotate: -45 * Math.PI / 180
        },
        autoRotate: false
      },
      labelOffset: 0,
      title: false
    })
    chart.col('observedTimestamp', {
      nice: true,
      tickCount: 22,
      min: startDate,
      max: endDate
    })
    // chart.legend(true)
    // chart.legend(true)
    chart.legend('typeName', {
      position: 'left',
      title: false
    })
    chart.axis('value', {
      title: false
    })
    chart.render()
  })
  return <Line data={dataSource} width={_get(config, 'ui.chartWidth')} height={_get(config, 'ui.chartHeight')} plotCfg={{
    margin: [10, 10, 70, 160]
  }} />
}
export default compose(
  inject('data'),
  inject('view'),
  observer
)(ForcingDataChart)



// WEBPACK FOOTER //
// ./src/modules/Forecasting/ForcingDataChart.js